import { gql } from '@apollo/client';
import { ENROLMENT } from '../fragments';

export const GET_ENROLMENT = gql`
  query GetEnrolment($id: ID!) {
    enrolment: getEnrolment(id: $id) {
      ...enrolment
    }
  }
  ${ENROLMENT}
`;
